import { FC, Suspense, useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

import { useDispatch } from '@bonusly/events';

import { useSurvicate } from './hooks';

export const AppContent: FC = () => {
	const location = useLocation();
	const navigate = useNavigate();
	const dispatch = useDispatch();

	useSurvicate();

	useEffect(() => {
		if (location.pathname === '/invite') {
			const to = setTimeout(() => {
				dispatch('open-user-invite-modal');
				navigate('');
			}, 1500);
			return () => clearTimeout(to);
		}
	}, [dispatch, location, navigate]);

	return (
		// No fallback: AppLoading prefetches the homepage chunk, so this boundary
		// only catches lazy chunks during client-side navigation.
		<Suspense>
			<Outlet />
		</Suspense>
	);
};
